import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorMessages } from '@app/shared/constants/constants';
import { EmployeeSkillsResponse } from '@app/shared/interfaces/employee-skiils';
import { environment } from '@environments/environment';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SkillsService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private toasterService: ToastrService,
  ) {}

  getEmployeeSkills(employeeId: string): Observable<EmployeeSkillsResponse> {
    return this.http
      .get<EmployeeSkillsResponse>(
        `${this.baseUrl}/hiring/employeeinfo-skills?employeeId=${employeeId}`,
      )
      .pipe(
        catchError((error) => {
          this.toasterService.error(ErrorMessages.NoDataAvailable);
          return throwError(() => error);
        }),
      );
  }
}
